import { Injectable } from '@angular/core';
import * as moment from 'moment';
@Injectable({
  providedIn: 'root'
})
export class ChangeDateFormateService {

  constructor() { }


  convertDate(date) {
    console.log("date is call or nor", date);

    let newDate = moment(date).format("YYYY-MM-DD")
    console.log("converted date formate", newDate);
    return newDate

  }
}
